import React from "react"
import Img from "gatsby-image"
import { useStaticQuery, graphql } from "gatsby"

const Logo = ({ alt, logo, link }) => {
  return (
    <div className="relative z-20 flex-1 w-20 sm:w-24 md:w-36">
      <a key={alt} href={link} target="#blank" rel="noref noopener">
        <Img fluid={logo} className="hover:opacity-50 transition-all"/>
      </a>
    </div>
  )
}

export default function Herologos() {
  const data = useStaticQuery(graphql`
    query HerologosQuery {
      allPrismicHomepageBodyHerologos {
        edges {
          node {
            items {
              link {
                url
              }
              logo_press {
                alt

                fluid {
                  ...GatsbyPrismicImageFluid_noBase64
                }
              }
            }
          }
        }
      }
    }
  `)
  return (
      <div className="relative z-20 mt- md:mt-12 lg:mt-24 md:shadow-xl py-4 md:p-12 flex items-center md:max-w-4xl mb-2 md:mb-6 md:w-full mx-auto space-x-4 sm:space-x-6 md:space-x-14">
        {data.allPrismicHomepageBodyHerologos.edges[0].node.items.map(
          ({ logo_press, alt, link }, index) => (
            <Logo logo={logo_press.fluid} alt={alt} link={link.url} key={index}/>
          )
        )}
      </div>
  )
}
